function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgTipoDeImovel = function SvgTipoDeImovel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.color,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 1,
    x: 0.667,
    y: 27,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.76 27.947v.016H8.753v-.016H3.12V13H.667L3.12 4h25.76l2.453 9H28.88v14.947H15.76zm-7.007-1V19.82c0-1.834 1.583-3.32 3.504-3.32s3.503 1.486 3.503 3.32v7.127h12.12V13H4.12v13.947h4.633zm1 0h5.007V19.82c0-1.268-1.12-2.32-2.503-2.32-1.382 0-2.504 1.053-2.504 2.32v7.127zM3.12 12h26.904l-1.908-7H3.884l-1.908 7H3.12zm15.947 5.267h5v5h-5v-5zm1 4h3v-3h-3v3z"
  })));
};

SvgTipoDeImovel.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgTipoDeImovel.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgTipoDeImovel;